angular.module("warehouses")

    .controller("WarehousesEditCtrl", ['LoginService', '$state', '$rootScope', '$stateParams', '$scope', 'Restangular', 'modalService', '$filter', '$translate',
        function (LoginService, $state, $rootScope,$stateParams, $scope, Restangular,modalService, $filter, $translate) {
            $scope.allowWrite = LoginService.permissionExist("WAREHOUSES_WRITE");


            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('warehouses.title'), url: "warehouses.list" },
                    { title: $filter('translate')('warehouses.button_add') }
                ];
                $scope.warehouses = {};

            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('warehouses.title'), url: "warehouses.list" },
                    { title: $filter('translate')('warehouses.button_edit'), url: "warehouses.edit({ id: " + $stateParams.id + " })" },
                ];

                Restangular.one('Warehouses', $stateParams.id).get().then(function (results) {
                    $scope.warehouses = results;
                });

            };


            $scope.save = function (frmWarehouses) {

                if (!angular.isUndefined($scope.warehouses.id)) {
                    $scope.warehouses.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('warehouses.edit_success'));
                            if ($scope.callbackFn != null) {
                                $scope.callbackFn(result);
                            } else {
                                $state.go("warehouses.list");
                            }
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    Restangular.all('Warehouses').post($scope.warehouses).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('warehouses.create_success'));
                            if ($scope.callbackFn != null) {
                                $scope.callbackFn(result);
                            } else {
                                $state.go("warehouses.list", { id: result.id, is_template: false });
                            }
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }
            }

            $scope.onCancel = function () {
                if ($scope.callbackFn != null) {
                    $scope.callbackFn(null);
                } else {
                    $state.go("warehouses.list");
                }
            };

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('warehouses.button_delete'),
                    message: $filter('translate')('warehouses.delete_message') + " " + $scope.warehouses.name + "?",
                    onAccept: function () {
                        $scope.warehouses.remove().then(function () {
                            toastr.success($filter('translate')('warehouses.delete_success'));
                            $state.go("warehouses.list");
                        });
                    }
                });
            };


        }]);